import cn from 'classnames';
import { forwardRef } from 'react';

import { Layout } from '@sravni/react-design-system';
import type { Button, ButtonProps } from '@sravni/react-design-system/dist/types/components/Button';

import { AnchorButton } from 'features/ProductList/ui/AnchorButton';

import styles from './MoreButton.module.scss';

export const MoreButton = forwardRef<typeof Button, ButtonProps & { text: string }>(({ className, text, onClick }) => (
  <div className={cn(styles.container, className)}>
    <Layout className={styles.layout}>
      <AnchorButton text={text} onClick={onClick} />
    </Layout>
  </div>
));
